import { criarFonteApi } from './fonteApi.js';

/**
 * Porta única de dados das cenas (`DP-TF-003`). Nenhuma cena lê a flag de
 * modo: recebe uma fonte pronta e chama os mesmos métodos nos dois modos.
 *
 * `__APP_MODE__` é substituído por literal no build (vite.config.js). Com
 * `prd`, o ramo abaixo vira código morto e o mock — inclusive o usuário de
 * teste — não entra no bundle (`DP-TF-004`).
 */
export async function criarFonteDeDados (dependencias = {}) {
    if (__APP_MODE__ === 'dev') {
        const { criarFonteMock } = await import('../game/data/mock/fonteMock.js');
        return criarFonteMock(dependencias.mock);
    }
    return criarFonteApi(dependencias);
}
